export const GAME_CONSTANTS = {
  // Time and Distance
  MAX_OFF_SCREEN_TIME: 2160,
  MAX_DISTANCE: 10,

  // Gas System
  MAX_GAS: 20,
  GAS_DECAY_RATE: 0.05,

  // Pellet System
  MAX_PELLETS: 10,
  PELLET_SPAWN_RATE: 0.05,
  PELLET_GAS_VALUE: 5,
};
